/**
 * ChipStack — casino chip button. Denomination-based colors, notched edge.
 * Used in the chip selector and stackable on bet circles.
 */
const CHIP_COLORS = {
    0.5:  { face: '#e6e6e6', edge: '#a0a0a0', label: '¢50', text: '#333' },
    1:    { face: '#ffffff', edge: '#c0c0c0', label: '$1', text: '#222' },
    5:    { face: '#e63946', edge: '#8a1a25', label: '$5', text: '#fff' },
    10:   { face: '#1d4ed8', edge: '#0b2a80', label: '$10', text: '#fff' },
    25:   { face: '#26a541', edge: '#0e5a25', label: '$25', text: '#fff' },
    50:   { face: '#ea580c', edge: '#8a3208', label: '$50', text: '#fff' },
    100:  { face: '#111111', edge: '#000', label: '$100', text: '#FFD700' },
    500:  { face: '#7c3aed', edge: '#3b0764', label: '$500', text: '#fff' },
};

export default function ChipStack({ value, selected, onClick }) {
    const c = CHIP_COLORS[value] || CHIP_COLORS[1];
    return (
        <button
            type="button"
            onClick={onClick}
            className={`relative w-11 h-11 md:w-16 md:h-16 rounded-full transition-transform ${selected ? 'scale-110 ring-2 ring-[#FFD700]' : 'hover:scale-105'}`}
            data-testid={`bj-chip-${value}`}
            title={`Add $${value} chip`}
            aria-label={`Chip ${value} dollars`}
            style={{
                background: `radial-gradient(circle at 30% 30%, ${c.face} 0%, ${c.face} 55%, ${c.edge} 100%)`,
                boxShadow: selected
                    ? '0 4px 12px rgba(255,215,0,0.5), inset 0 2px 4px rgba(255,255,255,0.4)'
                    : '0 3px 8px rgba(0,0,0,0.4), inset 0 2px 4px rgba(255,255,255,0.3)',
            }}
        >
            {/* Notched outer border pattern */}
            <span
                className="absolute inset-1 rounded-full border-2 border-dashed opacity-70"
                style={{ borderColor: c.edge }}
            />
            {/* Inner face circle */}
            <span
                className="absolute inset-2.5 rounded-full flex items-center justify-center font-black text-[10px] md:text-sm"
                style={{
                    background: c.face,
                    color: c.text,
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)',
                }}
            >
                {c.label}
            </span>
        </button>
    );
}
